import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2772e6ba")

_pushScopeId("data-v-2772e6ba")
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("b", null, "Please correct the following error(s):", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_8 = { class: "form-group grid" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "Detail", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editor = _resolveComponent("editor")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", {
    class: ["card", {loading: _ctx.loading}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.errors.length)
        ? (_openBlock(), _createBlock("p", _hoisted_2, [
            _hoisted_3,
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.notice.title = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.notice.title]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.editorContent
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("label", _hoisted_14, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    class: "c-switch-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.notice.show_yn_slider = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.notice.show_yn_slider]
                  ]),
                  _hoisted_15
                ])
              ])
            ])
          ]),
          _hoisted_16
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " 저장중...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ], 2))
})